import React, { useCallback, useState, useRef, useEffect } from 'react';
import moment from 'moment';
import ReactDOM from 'react-dom';
import { useDispatch, useSelector } from 'react-redux';
import { pathOr } from 'ramda';
import useStyles, { getMuiTheme } from "./styles";

import { MuiThemeProvider } from "@material-ui/core/styles";

import FullCalendar from '@fullcalendar/react';
import dayGridPlugin from '@fullcalendar/daygrid';
import timeGridPlugin from '@fullcalendar/timegrid';
import interactionPlugin from '@fullcalendar/interaction';
import listPlugin from '@fullcalendar/list';
import timelinePlugin from '@fullcalendar/timeline';
import CalendarTodayOutlinedIcon from '@material-ui/icons/CalendarTodayOutlined';
import DateRangeOutlinedIcon from '@material-ui/icons/DateRangeOutlined';
import ViewConfigIcon from '@material-ui/icons/ViewComfyOutlined';
import ViewWeekIcon from '@material-ui/icons/ViewWeekOutlined';
import ViewDayIcon from '@material-ui/icons/ViewDayOutlined';
import ViewAgendaIcon from '@material-ui/icons/ViewAgendaOutlined';


import {
  Modal,
  Card,
  CardContent,

  useTheme,
  useMediaQuery,
} from '@material-ui/core';
import '@fullcalendar/core/main.css';
import '@fullcalendar/daygrid/main.css';
import '@fullcalendar/timegrid/main.css';
import '@fullcalendar/list/main.css';
import { Skeleton } from '../../components';

import { getCalendarListView } from '../../store/actions/calendar.actions';

import QuickCreate from "../DetailView/components/quickCreate/quickCreate";

import { Page, AddEditEvent, ShowEventDetail, Toolbar } from './components';
import { textEllipsis } from './../../common/utils';


function useWindowSize() {
  // Initialize state with undefined width/height so server and client renders match
  // Learn more here: https://joshwcomeau.com/react/the-perils-of-rehydration/
  const [windowSize, setWindowSize] = useState({
    width: undefined,
    height: undefined,
  });
  useEffect(() => {
    // Handler to call on window resize
    function handleResize() {
      // Set window width/height to state
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    }
    // Add event listener
    window.addEventListener("resize", handleResize);
    // Call handler right away so state gets updated with initial window size
    handleResize();
    // Remove event listener on cleanup
    return () => window.removeEventListener("resize", handleResize);
  }, []); // Empty array ensures that effect is only run on mount
  return windowSize;
}

const Calendar = ({ module }) => {
  const classes = useStyles();
  const currentTheme = useTheme();

  const dispatch = useDispatch();
  const { CalendarListViewLoading, CalendarListViewError, CalendarListViewTabData } = useSelector((state) => state.calendar);
  const { userPreference} = useSelector((state) => state.config);
  const viewPrefType = pathOr('week', ['attributes', 'global','v3CalendarType'], userPreference);
	
  const calendarRef = useRef(null);
  const theme = useTheme();
  const mobileDevice = useMediaQuery(theme.breakpoints.down('sm'));
  const prererenceCalendarType = pathOr(viewPrefType, ["data",'CalendarType'], CalendarListViewTabData[module]);
const [viewOptions] = useState([

  {
    label: 'Month',
    value: 'dayGridMonth',
    icon: ViewConfigIcon,
    api:'month'
  },
  {
    label: 'Week',
    value: 'timeGridWeek',
    icon: ViewWeekIcon,
    api:'agendaWeek'
  },
  {
    label: 'Day',
    value: 'timeGridDay',
    icon: ViewDayIcon,
    api:'agendaDay'
  },
  {
    label: 'Agenda',
    value: 'listWeek',
    icon: ViewAgendaIcon,
    api:'agendaWeek'
  },
  {
    label: 'Shared Month',
    value: 'dayGridMonth',//'dayGridSharedMonth',
    icon: CalendarTodayOutlinedIcon,
    api:'sharedMonth'
  },
  {
    label: 'Shared Week',
    value: 'timeGridWeek',//'timeGridSharedWeek',
    icon: DateRangeOutlinedIcon,
    api:'sharedWeek'
  },
]);
let getCurrentView=viewOptions.find(o => o.api === prererenceCalendarType);
  // const [view, setView] = useState(mobileDevice ? 'listWeek' : 'dayGridWeek');
  // const [viewName,setViewName]=useState(mobileDevice?'Week':'Week');
  const [view, setView] = useState(getCurrentView?getCurrentView.value:'');
  const [viewName,setViewName]=useState(getCurrentView?getCurrentView.label:'');
  const [date, setMainDate] = useState(moment(new Date()).toDate());
  const [calendarStartDate, setCalendarStartDate] = useState(moment(new Date()).toDate());
  const [calendarEndDate, setCalendarEndDate] = useState(moment(new Date()).toDate());
  const [isRecordCreated, setIsSubpanelUpdated] = useState(false);
  const [events, setEvents] = useState({});

  const {currentUserData } = useSelector((state) => state.config);
  const currentUser = pathOr([], ["data", 'id'], currentUserData);
  let legendColor = pathOr([], ["data", 'legendColor'], CalendarListViewTabData[module]);
  const [userData, setUserData] = useState([currentUser]);
  
  const size = useWindowSize();


  const [eventModal, setEventModal] = useState({
    open: false,
    id: null,
    module: null
  });
  const [showDialogOpen, setShowDialogOpen] = useState({
    open: false,
    id: null,
    module: null

  });

  const [openQuickCreateDialog, setOpenQuickCreateDialog] = useState(false);
  const [selectedDate, setSelectedDate] = useState("");
  const [calendarViewType, setCalendarViewType] = useState(getCurrentView?getCurrentView.api:'');
  const [whichQuickCreate, setWhichQuickCreate] = useState(null);

  /* Added for agenda view color legend */
  if('listWeek' === view)
  {
    legendColor = 
      {
        "Today Open Item": '#FFA500',
        "Past Open Item": '#d32f2f',
        "Future Open Item": currentTheme.palette.primary.main,
        "Completed Item": '#3CD4A0',
      };

  }
  const getCalenderViewData = useCallback(() => {

    let newDate = date;
    let month = newDate.getMonth() + 1;
    let year = newDate.getFullYear();
    let firstDay = '';
    let lastDay = '';
    let calendarView = getCurrentView?getCurrentView.api:'';
    let firstDate = '';
    let lastDate = '';
    switch (view) {
      // case "listWeek":
      // case "timeGridWeek":
        
      //   // var first = newDate.getDate() - newDate.getDay(); // First day is the day of the month - the day of the week
      //   // var last = first + 6; // last day is the first day + 6
      //   calendarView = viewName==='Shared Week'?'sharedWeek':'agendaWeek';

      //   var first = new Date(newDate.getTime() - newDate.getDay() * 24 * 60 * 60 * 1000);
      //   var last = new Date(newDate.getTime() + (6 - newDate.getDay()) * 24 * 60 * 60 * 1000);
      //   firstDay = first.getDate();//new Date(newDate.setDate(first)).getDate();
      //   lastDay = last.getDate();//new Date(newDate.setDate(last)).getDate();
      //   firstDate = first.getFullYear() + "-" + (first.getMonth() + 1) + "-" + firstDay;
      //   lastDate = last.getFullYear() + "-" + (last.getMonth() + 1) + "-" + lastDay;
       
      //   break;
      case "timeGridDay":
        calendarView = 'agendaDay'
        firstDay = new Date(newDate).getDate();
        lastDay = new Date(newDate).getDate();
        firstDate = year + "-" + month + "-" + firstDay;
        lastDate = year + "-" + month + "-" + lastDay;
        break;
      case "dayGridMonth":  
        firstDay = new Date(newDate.getFullYear(), newDate.getMonth(), 1).getDate();
        lastDay = new Date(newDate.getFullYear(), newDate.getMonth() + 1, 0).getDate();
        calendarView = viewName==='Shared Month'?'sharedMonth':'month';
        firstDate = year + "-" + month + "-" + firstDay;
        lastDate = year + "-" + month + "-" + lastDay;
        break;
        default:
          calendarView = viewName==='Shared Week'?'sharedWeek':'agendaWeek';

          var first = new Date(newDate.getTime() - newDate.getDay() * 24 * 60 * 60 * 1000);
          var last = new Date(newDate.getTime() + (6 - newDate.getDay()) * 24 * 60 * 60 * 1000);
          firstDay = first.getDate();//new Date(newDate.setDate(first)).getDate();
          lastDay = last.getDate();//new Date(newDate.setDate(last)).getDate();
          firstDate = first.getFullYear() + "-" + (first.getMonth() + 1) + "-" + firstDay;
          lastDate = last.getFullYear() + "-" + (last.getMonth() + 1) + "-" + lastDay;
         
          break;
    }
    

    setCalendarViewType(calendarView)
    setCalendarStartDate(firstDate)
    setCalendarEndDate(lastDate)
    module && dispatch(getCalendarListView(firstDate, lastDate, calendarView,userData)).then(response => {
      let [...rest] = [pathOr({}, ['data','calendardata'], response)];
      if('listWeek' === view)
      {
        /* Added for agenda view color scheme */
        rest[0].map((legendColor1, i) => {
          if(legendColor1.status === "Planned" || legendColor1.status === "Not Started" || legendColor1.status === "In Progress")
          {
            if(legendColor1.dayType === 'today')
            {
              rest[0][i]['color'] = "#FFA500"; 
            }
            else if(legendColor1.dayType === 'past')
            {
              rest[0][i]['color'] = "#d32f2f"; 
            }
            else if(legendColor1.dayType === 'future')
            {
              rest[0][i]['color'] = currentTheme.palette.primary.main; 
            }          
          }
          else if(legendColor1.status === "Held" || legendColor1.status === "Completed")
          {
            rest[0][i]['color'] = "#3CD4A0"; 
          }
        })
      }
      setEvents({ draft: [], 'events': rest[0] });
      // if(userData[0]===currentUser && userData.length===1){
      // setUserData(pathOr({}, ['data','user_ids'], response))

      // }
      // setEvents({ draft: [], 'events': [
      //   {
      //     title: 'BCH237',
      //     start: '2021-06-12T10:30:00',
      //     end: '2021-06-12T11:30:00',
      //     extendedProps: {
      //       department: 'BioChemistry',
      //       description: 'Lecture'
            
      //     },
      //     department2: 'BioChemistry',
      //     description2: 'Lecture'
      //   }
      // ] });
     

    });
  }, [dispatch, module, date, viewName,userData])

  useEffect(() => {
    getCalenderViewData();

  }, [getCalenderViewData])

  useEffect(() => {
    if (isRecordCreated) {
      getCalenderViewData();
      setIsSubpanelUpdated(false)
    }
  }, [isRecordCreated])
  // useEffect(() => {
  //   const calendarApi = calendarRef.current.getApi();
  //   const newView = mobileDevice ? 'listWeek' : 'dayGridMonth';

  //   calendarApi.changeView(newView);
  //   setView(newView);
  // }, [mobileDevice]);

  const handleEventClick = info => {
    const selected = events['events'].find(event => event.id === info.event.id);

    setShowDialogOpen({
      open: true,
      id: selected.id,
      module: selected.module_name

    });
  };

  const handleEventNew = (event) => {

    setEventModal({
      open: true,
      event: null
    });
  };

  // const handleEventDelete = event => {
  //   setEvents(events => events.filter(e => e.id !== event.id));
  //   setEventModal({
  //     open: false,
  //     event: null
  //   });
  // };

  // const handleModalClose = () => {
  //   setEventModal({
  //     open: false,
  //     event: null
  //   });
  // };

  // const handleEventAdd = event => {
  //   setEvents(events => [...events, event]);
  //   setEventModal({
  //     open: false,
  //     event: null
  //   });
  // };

  // const handleEventEdit = event => {

  //   setEvents(events => events.map(e => (e.id === event.id ? event : e)));
  //   setEventModal({
  //     open: false,
  //     event: null
  //   });
  // };

  const handleDateToday = () => {
    const calendarApi = calendarRef.current.getApi();

    calendarApi.today();
    setMainDate(calendarApi.getDate());
  };

  const handleViewChange = (view) => {
    const calendarApi = calendarRef.current.getApi();
    calendarApi.changeView(view);
    setView(view);
  };

  const handleDatePrev = () => {

    const calendarApi = calendarRef.current.getApi();

    calendarApi.prev();
    setMainDate(calendarApi.getDate());
  };

  const handleDateNext = () => {
    const calendarApi = calendarRef.current.getApi();

    calendarApi.next();
    setMainDate(calendarApi.getDate());
  };


  if (CalendarListViewError) {
    return <h3>{CalendarListViewError}</h3>;
  }

  const handleDateClick = (info) => {
    let dd =info.date;
    // let nd=dd.getFullYear()+"-"+dd.getMonth()+"-"+dd.getDate()+" "+dd.getHours()+":"+dd.getMinutes()+":"+dd.getSeconds();
    let nd= dd.getFullYear() + "-" + ("0" + (dd.getMonth() + 1)).slice(-2) + "-" + ("0" + dd.getDate()).slice(-2) + " " + ("0" + dd.getHours()).slice(-2) + ":" + ("0" + dd.getMinutes()).slice(-2) + ":" + ("0" + dd.getSeconds()).slice(-2)
	
    var today = new Date();

    let todayCurrentTime = ("0" + today.getHours()).slice(-2) + ":" + ("0" + today.getMinutes()).slice(-2) + ":" + ("0" + today.getSeconds()).slice(-2)
   
    setSelectedDate(viewName==='month' || viewName==='Shared Month'?info.dateStr.substring(0, 10)+" "+todayCurrentTime:nd);
    setOpenQuickCreateDialog(!openQuickCreateDialog);
    setWhichQuickCreate("Meetings");
  }
  const EventDetail = ({ event, el }) => {
    // new Date(event.start.getFullYear(), event.start.getMonth(), 1).getDate()
    if(viewName!=='Agenda'){
    const content = 
    // viewName==='Agenda'?
    // <><td class="fc-list-item-time fc-widget-content">{event.extendedProps.start_time}</td><td class="fc-list-item-marker fc-widget-content"><span class="fc-event-dot" style={{backgroundColor:event.color}}></span></td><td class="fc-list-item-title fc-widget-content"><a>{" "+textEllipsis(event.title,50)+" "}</a></td><td>{event.extendedProps.assigned_user_name}</td></>
    // :
    <div className="fc-content"><b>{event.extendedProps.start_time}</b><span>{" "+textEllipsis(event.title,25)+" "}</span><br/><b>{event.extendedProps.assigned_user_name}</b></div>;
    ReactDOM.render(content, el);
    return el;
    }
  };

  return (

    <Page
      className={classes.root}
      title="Calendar"
    >
      <Toolbar
        date={date}
        onDateNext={handleDateNext}
        onDatePrev={handleDatePrev}
        onDateToday={handleDateToday}
        onEventAdd={handleEventNew}
        onViewChange={handleViewChange}
        calendarStartDate={calendarStartDate}
        calendarEndDate={calendarEndDate}
        view={view}
        viewName={viewName}
        setViewName={setViewName}
        setUserData={setUserData}
        currentUser={currentUser}
        userData={userData}
        setIsSubpanelUpdated={setIsSubpanelUpdated}
        legendColor={legendColor}
        CalendarListViewLoading={CalendarListViewLoading}
        viewOptions={viewOptions}
      />
      <MuiThemeProvider theme={getMuiTheme(currentTheme)}>

        {CalendarListViewLoading ?
          <Skeleton /> :
          <Card className={classes.card}>
            <CardContent>
              <FullCalendar
                allDayMaintainDuration
                defaultDate={date}
                defaultView={view}
                droppable
                editable
                eventClick={handleEventClick}
                dateClick={(info) => handleDateClick(info)}
                eventResizableFromStart
                events={events}
                eventRender={EventDetail}
                // eventRender={info=>{ 
                //   var tooltip = new Tooltip(info.el, {
                //   title: info.event.extendedProps.description,
                //   placement: 'top',
                //   trigger: 'hover',
                //   container: 'body'
                // });}}
                header={false}
                height={((size.height - 200) > 750 ? size.height - 200 : 550)}
                //height={550}
                plugins={[
                  dayGridPlugin,
                  timeGridPlugin,
                  interactionPlugin,
                  listPlugin,
                  timelinePlugin
                ]}
                ref={calendarRef}
                rerenderDelay={10}
                selectable
                weekends
              />
            </CardContent>
          </Card>}
      </MuiThemeProvider>

      {/* <Modal
        onClose={handleModalClose}
        open={eventModal.open}
      >
        <AddEditEvent
          event={eventModal.event}
          // onAdd={handleEventAdd}
          // onCancel={handleModalClose}
          // onDelete={handleEventDelete}
          // onEdit={handleEventEdit}
          setIsSubpanelUpdated={setIsSubpanelUpdated}
        />
      </Modal> */}
      {showDialogOpen.open ? <ShowEventDetail showDialogOpen={showDialogOpen} setShowDialogOpen={setShowDialogOpen} /> : null}
      {openQuickCreateDialog ?
        <QuickCreate
          calendarView={true}
          selectedDate={selectedDate}
          openQuickCreateDialog={openQuickCreateDialog}
          setOpenQuickCreateDialog={setOpenQuickCreateDialog}
          setIsSubpanelUpdated={setIsSubpanelUpdated}
          whichQuickCreate={"Meetings"}
          parent_name={""}
          parent_id={""}
          parent_type={"Meetings"}
          value={""}
          setValue={""}
          calendarViewType={calendarViewType}
        /> : null}
    </Page>


  );
};

export default Calendar;
